// export default ProductMap = {
exports.ProductMap = {
  4: {
    '2kWh': [{
      name: 'Get Set Kit (2kWh)',
      pid: '7368071807130',
      varId: '42092724650138',
      adaptBatCap: 2,
      limit: 2,
      consoleChoose: 'Y',
      off_price: '6076',
      old_price: '6076',
      // save_money: '118',
      imgSrc: '/img/mm100/preview/setkit-2kw.jpg',
      delivery_date: 'Mid August 2022',
      accessories: ['1x Power Hub', '1x 2kWh LFP Battery', '1x Cable Pack'],
      detailImgList: ['power-2kw.jpg', 'wire.jpg'],
      desc: 'The Get Set Kit allows you to quickly build a basic electrical system for your van/off-grid home using an LFP battery and Power Hub.'
    }, {
      name: 'Prepared Kit (2kWh)',
      pid: '7368071807130',
      varId: '42092724682906',
      adaptBatCap: 2,
      limit: 2,
      consoleChoose: 'Y',
      off_price: '6725',
      old_price: '6725',
      // save_money: '306',
      imgSrc: '/img/mm100/preview/prekit-2kw.jpg',
      delivery_date: 'Mid August 2022',
      accessories: ['1x Power Hub', '1x 2kWh LFP Battery', '1x Cable Pack', '1x AC / DC Smart Distribution Panel', '1x Battery Mounting Strap'],
      detailImgList: ['bundle-2kw-dp.jpg', 'wire.jpg'],
      desc: 'The Prepared Kit gives you more control over your power usage, offering comfort and convenience while traveling or living off-grid.'
    }, {
      name: 'Independence Kit (2kWh)',
      pid: '7368071807130',
      varId: '42092724715674',
      adaptBatCap: 2,
      limit: 2,
      off_price: '7214',
      old_price: '7214',
      // save_money: '315',
      imgSrc: '/img/mm100/preview/indkit-2kw-us.jpg',
      delivery_date: 'Mid August 2022',
      accessories: ['1x Power Hub', '1x 2kWh LFP Battery', '1x Cable Pack', '1x AC / DC Smart Distribution Panel', '1x Power Kit Console',
      // '1x Smart Generator',
      '1x Battery Mounting Strap'],
      detailImgList: ['bundle-2kw-all_us.jpg', 'wire.jpg'],
      desc: 'The Independence Kit provides a complete off-grid power solution. With the EcoFlow AC/DC Smart Distribution Panel and Power Kit Console, you can monitor, control, and customize your power from the wall or mobile app.'
    }],
    '4kWh': [{
      name: 'Get Set Kit (4kWh)',
      pid: '7368071872666',
      varId: '42092724846746',
      adaptBatCap: 2,
      limit: 1,
      consoleChoose: 'Y',
      off_price: '8315',
      old_price: '8315',
      // save_money: '477',
      imgSrc: '/img/mm100/preview/setkit-4kw.jpg',
      delivery_date: 'Mid August 2022',
      accessories: ['1x Power Hub', '2x 2kWh LFP Battery', '1x Cable Pack'],
      detailImgList: ['power-4kw.jpg', 'wire.jpg'],
      desc: 'The Get Set Kit allows you to quickly build a basic electrical system for your van/off-grid home using an LFP battery and Power Hub.'
    }, {
      name: 'Prepared Kit (4kWh)',
      pid: '7368071872666',
      varId: '42092724879514',
      adaptBatCap: 2,
      limit: 1,
      consoleChoose: 'Y',
      off_price: '8964',
      old_price: '8964',
      // save_money: '714',
      imgSrc: '/img/mm100/preview/prekit-4kw.jpg',
      delivery_date: 'Mid August 2022',
      accessories: ['1x Power Hub', '2x 2kWh LFP Battery', '1x Cable Pack', '1x AC / DC Smart Distribution Panel', '2x Battery Mounting Strap'],
      detailImgList: ['bundle-4kw-dp.jpg', 'wire.jpg'],
      desc: 'The Prepared Kit gives you more control over your power usage, offering comfort and convenience while traveling or living off-grid.'
    }, {
      name: 'Independence Kit (4kWh)',
      pid: '7368071872666',
      varId: '42092724912282',
      adaptBatCap: 2,
      limit: 1,
      off_price: '9453',
      old_price: '9453',
      // save_money: '723',
      imgSrc: '/img/mm100/preview/indkit-4kw-us.jpg',
      delivery_date: 'Mid August 2022',
      accessories: ['1x Power Hub', '2x 2kWh LFP Battery', '1x Cable Pack', '1x AC / DC Smart Distribution Panel', '1x Power Kit Console',
      // '1x Smart Generator',
      '2x Battery Mounting Strap'],
      detailImgList: ['bundle-4kw-all_us.jpg', 'wire.jpg'],
      desc: 'The Independence Kit provides a complete off-grid power solution. With the EcoFlow AC/DC Smart Distribution Panel and Power Kit Console, you can monitor, control, and customize your power from the wall or mobile app.'
    }],
    '5kWh': [{
      name: 'Get Set Kit (5kWh)',
      pid: '7368071905434',
      varId: '42092724945050',
      adaptBatCap: 5,
      limit: 2,
      consoleChoose: 'Y',
      off_price: '8956',
      old_price: '8956',
      // save_money: '238',
      imgSrc: '/img/mm100/preview/setkit-5kw.jpg',
      delivery_date: 'Mid August 2022',
      accessories: ['1x Power Hub', '1x 5kWh LFP Battery', '1x Cable Pack'],
      detailImgList: ['power-5kw.jpg', 'wire.jpg'],
      desc: 'The Get Set Kit allows you to quickly build a basic electrical system for your van/off-grid home using an LFP battery and Power Hub.'
    }, {
      name: 'Prepared Kit (5kWh)',
      pid: '7368071905434',
      varId: '42092724977818',
      adaptBatCap: 5,
      limit: 2,
      consoleChoose: 'Y',
      off_price: '9605',
      old_price: '9605',
      // save_money: '426',
      imgSrc: '/img/mm100/preview/prekit-5kw.jpg',
      delivery_date: 'Mid August 2022',
      accessories: ['1x Power Hub', '1x 5kWh LFP Battery', '1x Cable Pack', '1x AC / DC Smart Distribution Panel', '1x Battery Mounting Strap'],
      detailImgList: ['bundle-5kw-dp.jpg', 'wire.jpg'],
      desc: 'The Prepared Kit gives you more control over your power usage, offering comfort and convenience while traveling or living off-grid.'
    }, {
      name: 'Independence Kit (5kWh)',
      pid: '7368071905434',
      varId: '42092725010586',
      adaptBatCap: 5,
      limit: 2,
      off_price: '10094',
      old_price: '10094',
      // save_money: '435',
      imgSrc: '/img/mm100/preview/indkit-5kw-us.jpg',
      delivery_date: 'Mid August 2022',
      accessories: ['1x Power Hub', '1x 5kWh LFP Battery', '1x Cable Pack', '1x AC / DC Smart Distribution Panel', '1x Power Kit Console',
      // '1x Smart Generator',
      '1x Battery Mounting Strap'],
      detailImgList: ['bundle-5kw-all_us.jpg', 'wire.jpg'],
      desc: 'The Independence Kit provides a complete off-grid power solution. With the EcoFlow AC/DC Smart Distribution Panel and Power Kit Console, you can monitor, control, and customize your power from the wall or mobile app.'
    }],
    '10kWh': [{
      name: 'Get Set Kit (10kWh)',
      pid: '7368071938202',
      varId: '42092725043354',
      adaptBatCap: 5,
      limit: 1,
      consoleChoose: 'Y',
      off_price: '14075',
      old_price: '14075',
      // save_money: '1617',
      imgSrc: '/img/mm100/preview/setkit-10kw.jpg',
      delivery_date: 'Mid August 2022',
      accessories: ['1x Power Hub', '2x 5kWh LFP Battery', '1x Cable Pack'],
      detailImgList: ['power-10kw.jpg', 'wire.jpg'],
      desc: 'The Get Set Kit allows you to quickly build a basic electrical system for your van/off-grid home using an LFP battery and Power Hub.'
    }, {
      name: 'Prepared Kit (10kWh)',
      pid: '7368071938202',
      varId: '42092725076122',
      adaptBatCap: 5,
      limit: 1,
      consoleChoose: 'Y',
      off_price: '14724',
      old_price: '14724',
      // save_money: '1854',
      imgSrc: '/img/mm100/preview/prekit-10kw.jpg',
      delivery_date: 'Mid August 2022',
      accessories: ['1x Power Hub', '2x 5kWh LFP Battery', '1x Cable Pack', '1x AC / DC Smart Distribution Panel', '2x Battery Mounting Strap'],
      detailImgList: ['bundle-10kw-dp.jpg', 'wire.jpg'],
      desc: 'The Prepared Kit gives you more control over your power usage, offering comfort and convenience while traveling or living off-grid.'
    }, {
      name: 'Independence Kit (10kWh)',
      pid: '7368071938202',
      varId: '42092725108890',
      adaptBatCap: 5,
      limit: 1,
      off_price: '15213',
      old_price: '15213',
      // save_money: '1863',
      imgSrc: '/img/mm100/preview/indkit-10kw-us.jpg',
      delivery_date: 'Mid August 2022',
      accessories: ['1x Power Hub', '2x 5kWh LFP Battery', '1x Cable Pack', '1x AC / DC Smart Distribution Panel', '1x Power Kit Console',
      // '1x Smart Generator',
      '2x Battery Mounting Strap'],
      detailImgList: ['bundle-10kw-all_us.jpg', 'wire.jpg'],
      desc: 'The Independence Kit provides a complete off-grid power solution. With the EcoFlow AC/DC Smart Distribution Panel and Power Kit Console, you can monitor, control, and customize your power from the wall or mobile app.'
    }],
    '15kWh': [{
      name: 'Get Set Kit (15kWh)',
      pid: '7368072003738',
      varId: '42092725174426',
      consoleChoose: 'Y',
      off_price: '19194',
      old_price: '19194',
      // save_money: '2996',
      imgSrc: '/img/mm100/preview/setkit-15kw.jpg',
      delivery_date: 'Mid August 2022',
      accessories: ['1x Power Hub', '3x 5kWh LFP Battery', '1x Cable Pack'],
      detailImgList: ['power-15kw.jpg', 'wire.jpg'],
      desc: 'The Get Set Kit allows you to quickly build a basic electrical system for your van/off-grid home using an LFP battery and Power Hub.'
    }, {
      name: 'Prepared Kit (15kWh)',
      pid: '7368072003738',
      varId: '42092725207194',
      consoleChoose: 'Y',
      off_price: '19843',
      old_price: '19843',
      // save_money: '3282',
      imgSrc: '/img/mm100/preview/prekit-15kw.jpg',
      delivery_date: 'Mid August 2022',
      accessories: ['1x Power Hub', '3x 5kWh LFP Battery', '1x Cable Pack', '1x AC / DC Smart Distribution Panel', '3x Battery Mounting Strap'],
      detailImgList: ['bundle-15kw-dp.jpg', 'wire.jpg'],
      desc: 'The Prepared Kit gives you more control over your power usage, offering comfort and convenience while traveling or living off-grid.'
    }, {
      name: 'Independence Kit (15kWh)',
      pid: '7368072003738',
      varId: '42092725239962',
      off_price: '20332',
      old_price: '20332',
      // save_money: '3291',
      imgSrc: '/img/mm100/preview/indkit-15kw-us.jpg',
      delivery_date: 'Mid August 2022',
      accessories: ['1x Power Hub', '3x 5kWh LFP Battery', '1x Cable Pack', '1x AC / DC Smart Distribution Panel', '1x Power Kit Console',
      // '1x Smart Generator',
      '3x Battery Mounting Strap'],
      detailImgList: ['bundle-15kw-all_us.jpg', 'wire.jpg'],
      desc: 'The Independence Kit provides a complete off-grid power solution. With the EcoFlow AC/DC Smart Distribution Panel and Power Kit Console, you can monitor, control, and customize your power from the wall or mobile app.'
    }]
  }
};
exports.solarPanelMap = {
  4: [{
    name: '2*100W Rigid Solar Panel+2*Rigid solar mounting feet',
    pid: '7368078721178',
    varId: '42092741820570',
    old_price: '279',
    off_price: '279',
    // save_money: '0',
    limit: 99,
    // discount: "%1=369%%2=729%%3=1089%%n={per=1,off=0}%",
    imgSrc: '/img/mm100/preview/rigid-100w.jpg'
  }, {
    name: '2*400W Rigid Solar Panel+4*Rigid solar mounting feet',
    pid: '7368089960602',
    varId: '42092763152538',
    old_price: '939',
    off_price: '939',
    // save_money: '0',
    tips: '*This item excludes free shipping.',
    limit: 99,
    imgSrc: '/img/mm100/preview/rigid-400w.jpg'
  }, {
    name: '1*100W Flexible Solar Panel',
    pid: '7368078786714',
    varId: '42092741984410',
    old_price: '249',
    off_price: '249',
    // save_money: '0',
    limit: 99,
    imgSrc: '/img/mm100/preview/flexibel-100w.jpg'
  }, {
    name: '1*400W Portable Solar Panel',
    pid: '7287920001178',
    varId: '42092770263194',
    old_price: '1399',
    off_price: '1399',
    // save_money: '0',
    limit: 99,
    imgSrc: '/img/mm100/preview/flexibel-400w.jpg'
  }]
};
exports.BatteryMap = {
  4: [{
    name: '2kWh LFP Battery',
    pid: '7368075673754',
    varId: '42092735922330',
    off_price: '2239',
    old_price: '2239',
    // save_money: '0',
    capacity: 2,
    imgSrc: '/img/mm100/preview/battery-2kw.jpg'
  }, {
    name: '5kWh LFP Battery',
    pid: '7368075673754',
    varId: '42092735955098',
    off_price: '5119',
    old_price: '5119',
    // save_money: '0',
    capacity: 5,
    imgSrc: '/img/mm100/preview/battery-5kw.jpg'
  }]
};
exports.InstallationMap = {
  4: {
    pid: '7372311625882',
    varId: '42108111126682',
    off_price: '0',
    old_price: '0',
    save_money: '0'
  }
};
exports.ConsoleMap = {
  4: [{
    name: 'EcoFlow Power Kits Console',
    pid: '7395524247706',
    varId: '42189050609818',
    off_price: '489',
    old_price: '489',
    limit: 1,
    // save_money: '599',
    prdType: 'console',
    imgSrc: '/img/calculators/mm100/combo-console.jpg'
  }]
};
exports.ShopifyUrl = 'https://ca.ecoflow.com/';